import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type BackOfficeCreateBugReport = {
    description?: string;
    attachment?: FormData;
};

export default async ({
    description,
    attachment,
}: BackOfficeCreateBugReport = {}) => {
    const headers = {
        auth: true,
        description,
    };
    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/backoffice/report`,
        method: "post",
        headers,
        body: attachment,
    });
    const { body, statusCode } = httpRequest;

    const errorFeedBacks = {};

    return handleStatusCases({ body, statusCode, errorFeedBacks });
};
